import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { ProductForm } from './ProductFormShared';

const api = axios.create({ baseURL: '/api' });
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

const PLATFORMS = [
  { code: 'SMARTSTORE', name: 'S' },
  { code: 'ELEVENST', name: '11st' },
  { code: 'GMARKET', name: 'G' },
  { code: 'AUCTION', name: 'A' },
  { code: 'COUPANG', name: 'C' },
  { code: 'SELLERHUB', name: 'Hub' },
  { code: 'TOSS', name: 'T' },
];

const STATUS_CONFIG = {
  '등록':   { color: '#534AB7', bg: '#EEEDFE' },
  '판매중': { color: '#0F6E56', bg: '#E1F5EE' },
  '판매중지': { color: '#A32D2D', bg: '#FCEBEB' },
  '품절':   { color: '#854F0B', bg: '#FAEEDA' },
};

function StatusBadge({ status, onChange, productId }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const btnRef = useState(null);
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG['등록'];
  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <span ref={el => btnRef[0] = el} onClick={(e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setPos({ top: rect.bottom + 4, left: rect.left });
        setOpen(p=>!p);
      }} style={{ fontSize: '11px', padding: '3px 8px', borderRadius: '6px', background: cfg.bg, color: cfg.color, fontWeight: '500', cursor: 'pointer', userSelect: 'none' }}>
        {status} ▾
      </span>
      {open && (
        <>
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9998 }} onClick={() => setOpen(false)} />
          <div style={{ position: 'fixed', top: pos.top, left: pos.left, background: '#fff', border: '0.5px solid #e8e8e8', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 9999, minWidth: '90px' }}>
          {Object.keys(STATUS_CONFIG).map(s => (
            <div key={s} onClick={async () => {
              if (s === status) { setOpen(false); return; }
              const msg = (s==='판매중지'||s==='품절') ? `${s}로 변경하면 재고가 0이 됩니다. 계속하시겠습니까?` : `${s}로 변경하시겠습니까?`;
              if (!window.confirm(msg)) { setOpen(false); return; }
              await api.patch(`/products/${productId}/status`, { status: s });
              onChange();
              setOpen(false);
            }} style={{ padding: '7px 12px', fontSize: '12px', cursor: 'pointer', color: STATUS_CONFIG[s].color, background: s===status?STATUS_CONFIG[s].bg:'#fff' }}
              onMouseEnter={e=>e.target.style.background=STATUS_CONFIG[s].bg}
              onMouseLeave={e=>e.target.style.background=s===status?STATUS_CONFIG[s].bg:'#fff'}>
              {s}
            </div>
          ))}
        </div>
        </>
      )}
    </div>
  );
}


function ProductDetail({ product, onClose, onEdit }) {
  const cfg = STATUS_CONFIG[product.status] || STATUS_CONFIG['등록'];
  const prices = product.prices || [];
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: '#fff', borderRadius: '14px', width: '600px', maxHeight: '85vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}>
        <div style={{ padding: '16px 20px', borderBottom: '0.5px solid #e8e8e8', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, background: '#fff', borderRadius: '14px 14px 0 0', zIndex: 1 }}>
          <span style={{ fontSize: '14px', fontWeight: '600' }}>상품 상세정보</span>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={onEdit} style={{ fontSize: '12px', padding: '5px 14px', borderRadius: '8px', border: '0.5px solid #1D9E75', background: '#E1F5EE', color: '#0F6E56', cursor: 'pointer' }}>수정</button>
            <button onClick={onClose} style={{ fontSize: '18px', color: '#aaa', background: 'none', border: 'none', cursor: 'pointer' }}>✕</button>
          </div>
        </div>
        <div style={{ padding: '20px' }}>
          <div style={{ display: 'flex', gap: '16px', marginBottom: '20px' }}>
            {product.thumbnail ? (
              <img src={`https://admin.jinhalife.co.kr${product.thumbnail}`} alt="" style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '8px', border: '0.5px solid #e8e8e8', flexShrink: 0 }} />
            ) : (
              <div style={{ width: '100px', height: '100px', background: '#f0f0f0', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', color: '#aaa', flexShrink: 0 }}>이미지없음</div>
            )}
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                <span style={{ fontSize: '14px', fontWeight: '600' }}>{product.name}</span>
                <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '6px', background: cfg.bg, color: cfg.color, fontWeight: '500' }}>{product.status}</span>
              </div>
              <div style={{ fontSize: '12px', color: '#185FA5', fontWeight: '500', marginBottom: '4px' }}>{product.product_code}</div>
              {product.large_category && <div style={{ fontSize: '11px', color: '#666' }}>{[product.large_category, product.middle_category, product.small_category, product.detail_category].filter(Boolean).join(' > ')}</div>}
              {product.tags && <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>태그: {product.tags}</div>}
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
            <div style={{ background: '#f9f9f9', borderRadius: '8px', padding: '12px' }}>
              <div style={{ fontSize: '11px', color: '#888', marginBottom: '8px', fontWeight: '500' }}>기본 정보</div>
              {[
                ['예상구매가', `${product.expected_price?.toLocaleString()}원`],
                ['재고', `${product.stock}개`],
                ['브랜드', product.brand||'-'],
                ['제조사', product.manufacturer||'-'],
                ['원산지', product.origin||'-'],
                ['과세유무', product.tax_type||'과세'],
              ].map(([k,v]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '4px' }}>
                  <span style={{ color: '#888' }}>{k}</span>
                  <span style={{ color: '#1a1a1a', fontWeight: '500' }}>{v}</span>
                </div>
              ))}
            </div>
            <div style={{ background: '#f9f9f9', borderRadius: '8px', padding: '12px' }}>
              <div style={{ fontSize: '11px', color: '#888', marginBottom: '8px', fontWeight: '500' }}>판매처별 가격</div>
              <div style={{ fontSize: '12px', color: '#1a1a1a', marginBottom: '4px' }}>기본 {product.expected_price?.toLocaleString()}원</div>
              {prices.map(p => (
                <div key={p.platform} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '4px' }}>
                  <span style={{ color: '#888' }}>{PLATFORMS.find(pl=>pl.code===p.platform)?.name || p.platform}</span>
                  <span style={{ color: '#1D9E75', fontWeight: '500' }}>{p.sale_price?.toLocaleString()}원</span>
                </div>
              ))}
            </div>
          </div>
          {(product.purchase_url || product.price_compare_url) && (
            <div style={{ marginBottom: '12px', display: 'flex', gap: '8px' }}>
              {product.purchase_url && <a href={product.purchase_url} target="_blank" rel="noreferrer" style={{ fontSize: '12px', padding: '5px 12px', borderRadius: '6px', border: '0.5px solid #185FA5', color: '#185FA5', textDecoration: 'none' }}>🔗 구매 링크</a>}
              {product.price_compare_url && <a href={product.price_compare_url} target="_blank" rel="noreferrer" style={{ fontSize: '12px', padding: '5px 12px', borderRadius: '6px', border: '0.5px solid #534AB7', color: '#534AB7', textDecoration: 'none' }}>📊 가격비교</a>}
            </div>
          )}
          {product.description && (
            <div style={{ background: '#f9f9f9', borderRadius: '8px', padding: '12px', fontSize: '12px', color: '#444', lineHeight: '1.6' }}>{product.description}</div>
          )}
          <div style={{ marginTop: '12px', fontSize: '11px', color: '#aaa', display: 'flex', justifyContent: 'space-between' }}>
            <span>등록일: {product.created_at ? new Date(product.created_at).toLocaleDateString('ko-KR') : '-'}</span>
            <span>최종수정: {product.updated_at ? new Date(product.updated_at).toLocaleDateString('ko-KR') : '-'}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
function ActionButton({ label, icon, onClick, busy, disabled, success, accent }) {
  const [hover, setHover] = useState(false);
  let bg = '#fff', border = '#ddd', color = '#555', cursor = 'pointer';
  if (success) { bg = '#E1F5EE'; border = '#1D9E75'; color = '#085041'; }
  else if (busy) { bg = '#E6F1FB'; border = '#185FA5'; color = '#185FA5'; cursor = 'progress'; }
  else if (disabled) { bg = '#f5f5f5'; border = '#eee'; color = '#bbb'; cursor = 'not-allowed'; }
  else if (hover) { bg = accent ? '#E6F1FB' : '#fafafa'; border = accent ? '#378ADD' : '#bbb'; color = accent ? '#185FA5' : '#333'; }
  else if (accent) { border = '#378ADD'; color = '#378ADD'; }
  return (
    <button
      onClick={onClick}
      disabled={disabled || busy}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ fontSize: '12px', padding: '8px 10px', borderRadius: '8px', border: '0.5px solid ' + border, background: bg, color, cursor, flex: 1, fontWeight: '500', transition: 'background 0.12s, border-color 0.12s, color 0.12s' }}
    >
      {success ? '완료' : busy ? '처리 중...' : label}
    </button>
  );
}
function SendStatusModal({ product, onClose, onSaved }) {
  const sentPlatforms = (product.platform_send_status || []).filter(s => s.status === '전송완료');
  // [버그 수정 - 2026-09-02] 이 입력값은 안내문구("기본가만 수정해주세요, 판매처별 판매가는 자동으로
  // 계산되어 반영됩니다")대로 반드시 "기본가"(products.expected_price)여야 한다.
  // 예전에는 실수로 "스마트스토어에 이미 마진 계산되어 전송된 판매가"를 초기값으로 써서,
  // 그 값을 그대로 다른 판매처(11번가/지마켓 등)에도 밀어넣는 심각한 버그가 있었다.
  const [salePrice, setSalePrice] = useState(product.expected_price || '');
  const [stockQuantity, setStockQuantity] = useState(product.stock || '');
  const [statusType, setStatusType] = useState('SALE');
  const [busyField, setBusyField] = useState(null);
  const [justDone, setJustDone] = useState(null);
  const [results, setResults] = useState(null);
  const [msg, setMsg] = useState('');
  const [coupangDetailHtml, setCoupangDetailHtml] = useState(null);
  const [coupangDetailLoading, setCoupangDetailLoading] = useState(false);
  const [copyDone, setCopyDone] = useState(false);
  const fetchCoupangDetail = async () => {
    setCoupangDetailLoading(true);
    setCopyDone(false);
    try {
      const r = await api.get(`/products/${product.id}/coupang-detail-html`);
      setCoupangDetailHtml(r.data.html);
    } catch (err) {
      alert('불러오기 실패: ' + (err.response?.data?.message || err.message));
    } finally {
      setCoupangDetailLoading(false);
    }
  };
  const copyCoupangDetail = () => {
    navigator.clipboard.writeText(coupangDetailHtml || '');
    setCopyDone(true);
    setTimeout(() => setCopyDone(false), 2000);
  };
  const PLATFORM_LABEL = { SMARTSTORE: '스마트스토어', ELEVENST: '11번가', GMARKET: '지마켓', AUCTION: '옥션', SELLERHUB: '셀러허브', COUPANG: '쿠팡', TOSS: '토스쇼핑' };
  const run = async (field) => {
    setBusyField(field);
    setMsg('');
    try {
      const body = { field };
      if (field === 'price' || field === 'all') body.salePrice = salePrice ? parseInt(salePrice) : undefined;
      if (field === 'stock' || field === 'all') body.stockQuantity = stockQuantity !== '' ? parseInt(stockQuantity) : undefined;
      if (field === 'status' || field === 'all') body.statusType = statusType;
      const r = await api.post(`/products/${product.id}/update-field`, body);
      setResults(r.data.results || []);
      const allOk = (r.data.results || []).every(x => x.success);
      setMsg(allOk ? '반영되었습니다.' : '일부 판매처에서 실패했습니다. 아래 결과를 확인하세요.');
      if (allOk) { setJustDone(field); setTimeout(() => setJustDone(null), 1500); }
      onSaved && onSaved();
    } catch (err) {
      setMsg('실패: ' + (err.response?.data?.message || err.message));
    } finally {
      setBusyField(null);
    }
  };
  const sl = { fontSize: '11px', color: '#888', marginBottom: '4px' };
  const inp = { fontSize: '13px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' };
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '520px', maxHeight: '85vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '4px' }}>
          <div style={{ fontSize: '15px', fontWeight: '600' }}>{product.name}</div>
          <button onClick={onClose} style={{ width: '24px', height: '24px', padding: 0, border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '16px', color: '#888' }}>×</button>
        </div>
        <div style={{ fontSize: '12px', color: '#888', marginBottom: '14px' }}>{product.product_code}</div>
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '18px' }}>
          {sentPlatforms.length === 0 ? (
            <span style={{ fontSize: '12px', color: '#aaa' }}>아직 전송된 판매처가 없습니다</span>
          ) : sentPlatforms.map(s => (
            <span key={s.platform} style={{ fontSize: '11px', padding: '3px 9px', borderRadius: '6px', background: '#E1F5EE', color: '#085041' }}>{PLATFORM_LABEL[s.platform] || s.platform}</span>
          ))}
        </div>
        {sentPlatforms.some(s => s.platform === 'SELLERHUB') && (
          <div style={{ fontSize: '12px', color: '#E24B4A', fontWeight: '600', marginBottom: '12px' }}>
            ⚠ 셀러허브는 수동으로 수정해주세요
          </div>
        )}
        {sentPlatforms.some(s => s.platform === 'COUPANG') && (
          <div style={{ fontSize: '12px', color: '#854F0B', fontWeight: '600', marginBottom: '12px' }}>
            ⚠ 쿠팡 상세설명은 아래 "쿠팡 상세설명 복사" 버튼을 이용해주세요
          </div>
        )}
        {sentPlatforms.length > 0 && (
          <>
            <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '10px' }}>일괄 수정 — 전송된 모든 판매처에 반영</div>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
              <div style={{ flex: 1 }}>
                <div style={sl}>기본가</div>
                <input type="number" value={salePrice} onChange={e => setSalePrice(e.target.value)} style={inp} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={sl}>재고</div>
                <input type="number" value={stockQuantity} onChange={e => setStockQuantity(e.target.value)} style={inp} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={sl}>판매상태</div>
                <select value={statusType} onChange={e => setStatusType(e.target.value)} style={{ ...inp, background: '#fff' }}>
                  <option value="SALE">판매중</option>
                  <option value="SUSPENSION">판매중지</option>
                </select>
              </div>
            </div>
            <div style={{ fontSize: '11px', color: '#aaa', lineHeight: '1.6', marginBottom: '16px' }}>
              기본가만 수정해주세요. 판매처별 판매가는 자동으로 계산되어 반영됩니다.<br/>
              재고 수량 0으로 하면 품절처리됩니다. (지마켓/옥션은 재고 0 시 자동으로 판매중지 처리됩니다)<br/>
              판매중지를 원하시면 판매상태를 변경하세요.
            </div>
            <div style={{ display: 'flex', gap: '6px', marginBottom: '10px' }}>
              <ActionButton label="가격" onClick={() => run('price')} busy={busyField === 'price'} disabled={!!busyField && busyField !== 'price'} success={justDone === 'price'} />
              <ActionButton label="재고" onClick={() => run('stock')} busy={busyField === 'stock'} disabled={!!busyField && busyField !== 'stock'} success={justDone === 'stock'} />
              <ActionButton label="판매상태" onClick={() => run('status')} busy={busyField === 'status'} disabled={!!busyField && busyField !== 'status'} success={justDone === 'status'} />
            </div>
            <div style={{ fontSize: '11px', color: '#aaa', lineHeight: '1.6', marginBottom: '8px' }}>
              대표이미지, 상세페이지, 고시정보 변경 시 아래 버튼을 눌러주세요.<br/>
              판매처에서 설정한 즉시할인·배송비·상품속성은 유지됩니다.
            </div>
            <div style={{ display: 'flex', gap: '6px', marginBottom: '18px' }}>
              <ActionButton label="상세설명 재전송" onClick={() => run('detail')} busy={busyField === 'detail'} disabled={!!busyField && busyField !== 'detail'} success={justDone === 'detail'} />
              <ActionButton label="전체 재전송" onClick={() => run('all')} busy={busyField === 'all'} disabled={!!busyField && busyField !== 'all'} success={justDone === 'all'} accent />
              {sentPlatforms.some(s => s.platform === 'COUPANG') && (
                <ActionButton label="쿠팡 상세설명 복사" onClick={fetchCoupangDetail} busy={coupangDetailLoading} disabled={coupangDetailLoading} success={false} />
              )}
            </div>
            {coupangDetailHtml != null && (
              <div style={{ marginBottom: '18px' }}>
                <div style={{ fontSize: '11px', color: '#854F0B', marginBottom: '6px' }}>
                  이 코드를 복사해 쿠팡 Wing 상세설명에 붙여넣은 후, 반드시 승인 요청을 다시 눌러주세요.
                </div>
                <textarea readOnly value={coupangDetailHtml} style={{ width: '100%', height: '100px', fontSize: '11px', fontFamily: 'monospace', padding: '8px', borderRadius: '8px', border: '0.5px solid #ddd', boxSizing: 'border-box' }} />
                <button onClick={copyCoupangDetail} style={{ marginTop: '6px', fontSize: '12px', padding: '6px 14px', borderRadius: '8px', border: '0.5px solid #7F77DD', background: copyDone ? '#E1F5EE' : '#EEEDFE', color: copyDone ? '#085041' : '#3C3489', cursor: 'pointer' }}>
                  {copyDone ? '복사됨!' : '복사'}
                </button>
              </div>
            )}
            {msg && <div style={{ fontSize: '12px', color: msg.startsWith('실패') ? '#A32D2D' : '#1D9E75', marginBottom: '8px' }}>{msg}</div>}
            {results && (
              <table style={{ width: '100%', fontSize: '12px', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ color: '#888', borderBottom: '0.5px solid #eee' }}>
                    <td style={{ padding: '6px 0' }}>판매처</td>
                    <td style={{ padding: '6px 0', textAlign: 'right' }}>결과</td>
                  </tr>
                </thead>
                <tbody>
                  {results.map((r, i) => (
                    <tr key={i}>
                      <td style={{ padding: '8px 0' }}>{PLATFORM_LABEL[r.platform] || r.platform}</td>
                      <td style={{ padding: '8px 0', textAlign: 'right', color: r.success ? '#1D9E75' : '#A32D2D' }}>
                        {r.appliedPrice != null && <span style={{ color: '#888', marginRight: '6px' }}>{r.appliedPrice.toLocaleString()}원</span>}
                        {r.success ? (r.message || '정상처리') : (r.message || '실패')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default function Products() {
  const location = useLocation(); // eslint-disable-line no-unused-vars
  const [products, setProducts] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [search, setSearch] = useState(() => new URLSearchParams(window.location.search).get('search') || '');
  const [statusFilter, setStatusFilter] = useState(() => new URLSearchParams(window.location.search).get('status') || '');
  // [기능 추가 - 2026-10-15] 등록마켓 필터: 선택한 마켓에 '전송완료'인 상품만 조회 (한 번에 한 마켓)
  const [marketFilter, setMarketFilter] = useState('');
  // [기능 추가 - 2026-10-23] 상품그룹 필터: ''=전체, 'none'=미분류, 그 외=그룹 id
  const [groupFilter, setGroupFilter] = useState('');
  const [productGroups, setProductGroups] = useState([]);
  useEffect(() => { api.get('/product-settings/product-groups').then(r => setProductGroups(r.data || [])).catch(() => {}); }, []);
  
  
  const [largeCat, setLargeCat] = useState('');
  const [middleCat, setMiddleCat] = useState('');
  const [smallCat, setSmallCat] = useState('');
  const [detailCat, setDetailCat] = useState('');
  const [largeList, setLargeList] = useState([]);
  const [middleList, setMiddleList] = useState([]);
  const [smallList, setSmallList] = useState([]);
  const [detailList, setDetailList] = useState([]);
  const [dateRange, setDateRange] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [priceMin, setPriceMin] = useState('');
  const [priceMax, setPriceMax] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get('/api/categories/large', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setLargeList(r.data))
      .catch(console.error);
  }, []);

  const handleLargeCat = async (val) => {
    setLargeCat(val); setMiddleCat(''); setSmallCat(''); setDetailCat('');
    setMiddleList([]); setSmallList([]); setDetailList([]);
    setCurrentPage(1);
    if (!val) return;
    const token = localStorage.getItem('token');
    const r = await axios.get(`/api/categories/middle?large=${encodeURIComponent(val)}`, { headers: { Authorization: `Bearer ${token}` } });
    setMiddleList(r.data);
  };

  const handleMiddleCat = async (val) => {
    setMiddleCat(val); setSmallCat(''); setDetailCat('');
    setSmallList([]); setDetailList([]);
    setCurrentPage(1);
    if (!val) return;
    const token = localStorage.getItem('token');
    const r = await axios.get(`/api/categories/small?large=${encodeURIComponent(largeCat)}&middle=${encodeURIComponent(val)}`, { headers: { Authorization: `Bearer ${token}` } });
    setSmallList(r.data);
  };

  const handleSmallCat = async (val) => {
    setSmallCat(val); setDetailCat('');
    setDetailList([]);
    setCurrentPage(1);
    if (!val) return;
    const token = localStorage.getItem('token');
    const r = await axios.get(`/api/categories/detail?large=${encodeURIComponent(largeCat)}&middle=${encodeURIComponent(middleCat)}&small=${encodeURIComponent(val)}`, { headers: { Authorization: `Bearer ${token}` } });
    setDetailList(r.data);
  };

  const handleDetailCat = (val) => {
    setDetailCat(val);
    setCurrentPage(1);
  };

  const handleDateRange = (range) => {
    setDateRange(range);
    const today = new Date();
    const fmt = d => d.toISOString().slice(0, 10);
    if (range === 'today') { setDateFrom(fmt(today)); setDateTo(fmt(today)); }
    else if (range === 'yesterday') {
      const y = new Date(today); y.setDate(y.getDate() - 1);
      setDateFrom(fmt(y)); setDateTo(fmt(y));
    }
    else if (range === '3days') { const d = new Date(today); d.setDate(d.getDate() - 2); setDateFrom(fmt(d)); setDateTo(fmt(today)); }
    else if (range === '7days') { const d = new Date(today); d.setDate(d.getDate() - 6); setDateFrom(fmt(d)); setDateTo(fmt(today)); }
    else { setDateFrom(''); setDateTo(''); }
    setCurrentPage(1);
  };
  const [selectedIds, setSelectedIds] = useState([]);
  const toggleSelect = (id) => setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const toggleAll = () => setSelectedIds(selectedIds.length === products.length ? [] : products.map(p => p.id));
  const handleBulkStatus = async (status) => {
    if (selectedIds.length === 0) return;
    if (!window.confirm(`선택한 ${selectedIds.length}개 상품을 "${status}"로 변경하시겠습니까?`)) return;
    try {
      const token = localStorage.getItem('token');
      await Promise.all(selectedIds.map(id => axios.patch(`/api/products/${id}/status`, { status }, { headers: { Authorization: `Bearer ${token}` } })));
      setSelectedIds([]);
      fetchProducts();
    } catch(e) { alert('상태 변경 실패'); }
  };

  const [editProduct, setEditProduct] = useState(null);
  const [sendStatusProduct, setSendStatusProduct] = useState(null);
  const [detailProduct, setDetailProduct] = useState(null);

  const fetchProducts = useCallback(async () => {
    try {
      const params = { page: currentPage, limit: pageLimit };
      if (search) params.search = search;
      if (statusFilter) params.status = statusFilter;
      if (marketFilter) { params.platform = marketFilter; params.platformStatus = 'sent'; }
      if (groupFilter) params.groupId = groupFilter;
      if (largeCat) params.largeCat = largeCat;
      if (middleCat) params.middleCat = middleCat;
      if (smallCat) params.smallCat = smallCat;
      if (detailCat) params.detailCat = detailCat;
      if (dateFrom) params.dateFrom = dateFrom;
      if (dateTo) params.dateTo = new Date(new Date(dateTo).getTime() + 86400000).toISOString().slice(0,10);
      if (priceMin) params.priceMin = priceMin;
      if (priceMax) params.priceMax = priceMax;
      const res = await api.get('/products', { params });
      setProducts(res.data.products);
      setTotal(res.data.total);
      setTotalPages(res.data.totalPages);
    } catch (err) { console.error(err); }
  }, [currentPage, search, statusFilter, marketFilter, groupFilter, pageLimit, dateFrom, dateTo, priceMin, priceMax, largeCat, middleCat, smallCat, detailCat]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (statusFilter) params.set('status', statusFilter);
    else params.delete('status');
    window.history.replaceState(null, '', params.toString() ? `?${params.toString()}` : window.location.pathname);
  }, [statusFilter]);

  useEffect(() => { fetchProducts(); }, [fetchProducts]);

  const handleDelete = async (id) => {
    if (!window.confirm('삭제하시겠습니까?\n\n※ 주의: 주문서에 판매된 이력이 있는 상품은 삭제되지 않습니다.')) return;
    try {
      await api.delete(`/products/${id}`);
      fetchProducts();
    } catch(e) {
      alert('삭제 실패: 주문서에 판매된 이력이 있는 상품은 삭제할 수 없습니다.');
    }
  };

  const handleSave = () => { setEditProduct(null); fetchProducts(); };

  if (editProduct) {
    return (
      <div style={{ minWidth: '1100px', maxWidth: '1100px' }}>
        <ProductForm product={editProduct} onSave={handleSave} onCancel={() => { setEditProduct(null); }} />
      </div>
    );
  }

  return (
    <div style={{ minWidth: '1100px', maxWidth: '1100px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h1 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>상품 관리</h1>
      </div>

      {/* 검색 필터 */}
      <div style={{ background: '#fff', border: '0.5px solid #e8e8e8', borderRadius: '12px', padding: '12px 16px', marginBottom: '14px', display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
        {/* [수정 - 2026-10-15] 상태 정의 안내: 필터 박스 안 오른쪽 칸(order:2). 박스 높이가 안내 영역에 맞춰 늘어난다 */}
        <div style={{ order: 2, width: '380px', flexShrink: 0, background: '#fafafa', border: '0.5px solid #e8e8e8', borderRadius: '10px', padding: '12px 14px' }}>
          <div style={{ fontSize: '12px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>상품 상태 정의</div>
          {[
            ['등록', '마켓 어디에도 전송이 완료되지 않은 상품입니다.'],
            ['판매중', '마켓 한 곳이라도 전송이 완료되어 판매 중인 상품입니다.'],
            ['품절', '일시적으로 팔 수 없는 상태입니다. 재고 0, 리뉴얼·상품내용 수정 등으로 잠시 내려야 할 때 쓰며, 곧 다시 판매합니다.'],
            ['판매중지', '상품을 내린 상태입니다. 단종, 제조사·저작권 문제 등으로 판매하지 못할 때 씁니다.'],
          ].map(([k, desc]) => (
            <div key={k} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', marginBottom: '6px' }}>
              <span style={{ flexShrink: 0, width: '58px', textAlign: 'center', fontSize: '11px', padding: '2px 0', borderRadius: '10px', background: STATUS_CONFIG[k]?.bg || '#f5f5f5', color: STATUS_CONFIG[k]?.color || '#444' }}>{k}</span>
              <span style={{ fontSize: '11px', color: '#444', lineHeight: '1.5' }}>{desc}</span>
            </div>
          ))}
          <div style={{ fontSize: '10.5px', color: '#888', lineHeight: '1.5', borderTop: '0.5px solid #eee', paddingTop: '6px', marginTop: '2px' }}>
            등록/판매중은 마켓 전송현황으로 자동 표시됩니다. 품절/판매중지는 오픈마켓 관리 창에서 재고·판매상태를 반영하면 저장됩니다.
          </div>
        </div>
        <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '12px', color: '#888', width: '60px', flexShrink: 0 }}>직접검색</span>
          <input value={search} onChange={e => { setSearch(e.target.value); setCurrentPage(1); }} placeholder="상품명 또는 상품코드"
            style={{ fontSize: '12px', padding: '5px 10px', borderRadius: '8px', border: '0.5px solid #e8e8e8', width: '260px' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '12px', color: '#888', width: '60px', flexShrink: 0 }}>카테고리</span>
          <select value={largeCat} onChange={e => handleLargeCat(e.target.value)}
            style={{ fontSize: '12px', padding: '5px 8px', borderRadius: '8px', border: '0.5px solid #e8e8e8', background: '#fff' }}>
            <option value="">대분류</option>
            {largeList.map(l => <option key={l} value={l}>{l}</option>)}
          </select>
          {middleList.length > 0 && (
            <select value={middleCat} onChange={e => handleMiddleCat(e.target.value)}
              style={{ fontSize: '12px', padding: '5px 8px', borderRadius: '8px', border: '0.5px solid #e8e8e8', background: '#fff' }}>
              <option value="">중분류</option>
              {middleList.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          )}
          {smallList.length > 0 && (
            <select value={smallCat} onChange={e => handleSmallCat(e.target.value)}
              style={{ fontSize: '12px', padding: '5px 8px', borderRadius: '8px', border: '0.5px solid #e8e8e8', background: '#fff' }}>
              <option value="">소분류</option>
              {smallList.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          )}
          {detailList.length > 0 && (
            <select value={detailCat} onChange={e => handleDetailCat(e.target.value)}
              style={{ fontSize: '12px', padding: '5px 8px', borderRadius: '8px', border: '0.5px solid #e8e8e8', background: '#fff' }}>
              <option value="">세분류</option>
              {detailList.map(d => <option key={d} value={d}>{d}</option>)}
            </select>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '12px', color: '#888', width: '60px', flexShrink: 0 }}>상품그룹</span>
          <select value={groupFilter} onChange={e => { setGroupFilter(e.target.value); setCurrentPage(1); }}
            style={{ fontSize: '12px', padding: '5px 8px', borderRadius: '8px', border: '0.5px solid #e8e8e8', background: '#fff', minWidth: '180px' }}>
            <option value="">전체</option>
            <option value="none">미분류</option>
            {productGroups.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
          </select>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ fontSize: '12px', color: '#888', width: '60px', flexShrink: 0 }}>상태</span>
          {[['', '전체'], ['등록', '등록'], ['판매중', '판매중'], ['품절', '품절'], ['판매중지', '판매중지']].map(([k,v]) => (
            <button key={k} onClick={() => { setStatusFilter(k); setCurrentPage(1); }}
              style={{ fontSize: '12px', padding: '5px 14px', borderRadius: '20px', border: `0.5px solid ${statusFilter===k?(STATUS_CONFIG[k]?.color||'#1D9E75'):'#e8e8e8'}`, background: statusFilter===k?(STATUS_CONFIG[k]?.bg||'#E1F5EE'):'#fff', color: statusFilter===k?(STATUS_CONFIG[k]?.color||'#0F6E56'):'#888', cursor: 'pointer', fontWeight: statusFilter===k?'500':'400' }}>
              {v}
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '12px', color: '#888', width: '60px', flexShrink: 0 }}>등록마켓</span>
          {[['', '전체'], ['SMARTSTORE', '스마트스토어'], ['ELEVENST', '11번가'], ['GMARKET', '지마켓'], ['AUCTION', '옥션'], ['COUPANG', '쿠팡'], ['SELLERHUB', '셀러허브'], ['TOSS', '토스쇼핑']].map(([k, v]) => (
            <button key={k} onClick={() => { setMarketFilter(k); setCurrentPage(1); }}
              style={{ fontSize: '12px', padding: '5px 12px', borderRadius: '20px', border: `0.5px solid ${marketFilter===k?'#1D9E75':'#e8e8e8'}`, background: marketFilter===k?'#E1F5EE':'#fff', color: marketFilter===k?'#0F6E56':'#888', cursor: 'pointer', fontWeight: marketFilter===k?'500':'400' }}>
              {v}
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '12px', color: '#888', width: '60px', flexShrink: 0 }}>등록일</span>
          {[['', '전체'], ['today', '오늘'], ['yesterday', '어제'], ['3days', '3일간'], ['7days', '7일간']].map(([k, v]) => (
            <button key={k} onClick={() => handleDateRange(k)}
              style={{ fontSize: '12px', padding: '5px 12px', borderRadius: '20px', border: `0.5px solid ${dateRange===k?'#1D9E75':'#e8e8e8'}`, background: dateRange===k?'#E1F5EE':'#fff', color: dateRange===k?'#0F6E56':'#888', cursor: 'pointer' }}>
              {v}
            </button>
          ))}
          <input type="date" value={dateFrom} onChange={e => { setDateFrom(e.target.value); setDateRange(''); setCurrentPage(1); }}
            style={{ fontSize: '12px', padding: '4px 8px', borderRadius: '8px', border: '0.5px solid #e8e8e8' }} />
          <span style={{ fontSize: '12px', color: '#aaa' }}>~</span>
          <input type="date" value={dateTo} onChange={e => { setDateTo(e.target.value); setDateRange(''); setCurrentPage(1); }}
            style={{ fontSize: '12px', padding: '4px 8px', borderRadius: '8px', border: '0.5px solid #e8e8e8' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ fontSize: '12px', color: '#888', width: '60px', flexShrink: 0 }}>구매가</span>
          <input type="number" value={priceMin} onChange={e => { setPriceMin(e.target.value); setCurrentPage(1); }} placeholder="최소금액"
            style={{ fontSize: '12px', padding: '4px 8px', borderRadius: '8px', border: '0.5px solid #e8e8e8', width: '90px' }} />
          <span style={{ fontSize: '12px', color: '#aaa' }}>~</span>
          <input type="number" value={priceMax} onChange={e => { setPriceMax(e.target.value); setCurrentPage(1); }} placeholder="최대금액"
            style={{ fontSize: '12px', padding: '4px 8px', borderRadius: '8px', border: '0.5px solid #e8e8e8', width: '90px' }} />
          <span style={{ fontSize: '12px', color: '#aaa' }}>원</span>
        </div>
        </div>
      </div>
      {products.length === 0 ? (
        <div style={{ background: '#fff', border: '0.5px solid #e8e8e8', borderRadius: '12px', padding: '60px', textAlign: 'center', color: '#aaa', fontSize: '14px' }}>등록된 상품이 없습니다</div>
      ) : (
        <div style={{ background: '#fff', border: '0.5px solid #e8e8e8', borderRadius: '12px', overflow: 'hidden' }}>
          {selectedIds.length > 0 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: '#E6F1FB', borderRadius: '8px', marginBottom: '10px', border: '0.5px solid #B5D4F4' }}>
              <span style={{ fontSize: '12px', color: '#185FA5', fontWeight: '500' }}>{selectedIds.length}개 선택됨</span>
              <span style={{ fontSize: '12px', color: '#888', marginRight: '4px' }}>상태 변경:</span>
              <button onClick={() => handleBulkStatus('판매중')} style={{ fontSize: '12px', padding: '4px 12px', borderRadius: '6px', border: 'none', background: '#1D9E75', color: '#fff', cursor: 'pointer' }}>판매중</button>
              <button onClick={() => handleBulkStatus('판매중지')} style={{ fontSize: '12px', padding: '4px 12px', borderRadius: '6px', border: 'none', background: '#888780', color: '#fff', cursor: 'pointer' }}>판매중지</button>
              <button onClick={() => handleBulkStatus('품절')} style={{ fontSize: '12px', padding: '4px 12px', borderRadius: '6px', border: 'none', background: '#E24B4A', color: '#fff', cursor: 'pointer' }}>품절</button>
              <span style={{ color: '#fff', fontSize: '16px', opacity: 0.5 }}>|</span>
            </div>
          )}
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', tableLayout: 'fixed' }}>
            <colgroup>
              <col style={{width:'36px'}}/>
              <col style={{width:'40px'}}/>
              <col style={{width:'90px'}}/>
              <col style={{width:'60px'}}/>
              <col style={{width:'110px'}}/>
              <col style={{width:'220px'}}/>
              <col style={{width:'120px'}}/>
              <col style={{width:'80px'}}/>
              <col style={{width:'100px'}}/>
              <col style={{width:'110px'}}/>
            </colgroup>
            <thead>
              <tr style={{ background: '#fafafa', borderBottom: '0.5px solid #e8e8e8' }}>
                <th style={{ padding: '10px 8px', textAlign: 'center' }}><input type="checkbox" checked={selectedIds.length === products.length && products.length > 0} onChange={toggleAll} style={{ cursor: 'pointer' }} /></th>
                <th style={{ padding: '10px 8px', textAlign: 'center', fontWeight: '500', color: '#666' }}>No</th>
                <th style={{ padding: '10px 8px', textAlign: 'center', fontWeight: '500', color: '#666' }}>상태</th>
                <th style={{ padding: '10px 8px', textAlign: 'center', fontWeight: '500', color: '#666' }}>이미지</th>
                <th style={{ padding: '10px 8px', textAlign: 'left', fontWeight: '500', color: '#666' }}>상품코드</th>
                <th style={{ padding: '10px 8px', textAlign: 'left', fontWeight: '500', color: '#666' }}>상품명</th>
                <th style={{ padding: '10px 8px', textAlign: 'left', fontWeight: '500', color: '#666' }}>판매가격</th>
                <th style={{ padding: '10px 8px', textAlign: 'center', fontWeight: '500', color: '#666' }}>등록일</th>
                <th style={{ padding: '10px 8px', textAlign: 'center', fontWeight: '500', color: '#666' }}>최종수정일</th>
                <th style={{ padding: '10px 8px', textAlign: 'center', fontWeight: '500', color: '#666' }}>전송현황</th>
                <th style={{ padding: '10px 8px', textAlign: 'center', fontWeight: '500', color: '#666' }}>관리</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, idx) => {
                return (
                  <tr key={product.id} style={{ borderBottom: '0.5px solid #f0f0f0' }}
                    onMouseEnter={e=>e.currentTarget.style.background='#f9f9f9'}
                    onMouseLeave={e=>e.currentTarget.style.background=''}>
                    <td style={{ padding: '10px 8px', textAlign: 'center' }}><input type="checkbox" checked={selectedIds.includes(product.id)} onChange={() => toggleSelect(product.id)} style={{ cursor: 'pointer' }} /></td>
                    <td style={{ padding: '10px 8px', textAlign: 'center', color: '#888' }}>{total - (currentPage-1)*pageLimit - idx}</td>
                    <td style={{ padding: '10px 8px', textAlign: 'center' }}>
                      <StatusBadge status={product.status||'등록'} productId={product.id} onChange={fetchProducts} />
                    </td>
                    <td style={{ padding: '10px 8px', textAlign: 'center' }}>
                      {product.thumbnail ? (
                        <img src={`https://admin.jinhalife.co.kr${product.thumbnail}`} alt="" style={{ width: '44px', height: '44px', objectFit: 'cover', borderRadius: '6px', border: '0.5px solid #e8e8e8' }} />
                      ) : (
                        <div style={{ width: '44px', height: '44px', background: '#f0f0f0', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '9px', color: '#aaa', margin: '0 auto' }}>없음</div>
                      )}
                    </td>
                    <td style={{ padding: '10px 8px', color: '#185FA5', fontWeight: '500', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{product.product_code}</td>
                    <td style={{ padding: '10px 8px', cursor: 'pointer' }} onClick={() => setDetailProduct(product)}>
                      <div style={{ fontWeight: '500', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{product.name}</div>
                      {product.tags && <div style={{ fontSize: '10px', color: '#aaa', marginTop: '2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{product.tags}</div>}
                    </td>
                    <td style={{ padding: '10px 8px' }}>
                      <div style={{ fontSize: '10px' }}>
                        {(() => {
                          const getPrice = (code) => { const pr = (product.prices||[]).find(pp=>pp.platform===code); return pr?.sale_price ? pr.sale_price.toLocaleString()+'원' : '-'; };
                          return [
                            { label: '기본', value: product.expected_price?.toLocaleString()+'원', base: true },
                            { label: 'S', value: getPrice('SMARTSTORE'), base: false },
                            { label: 'G/A', value: getPrice('GMARKET'), base: false },
                            { label: '11st', value: getPrice('ELEVENST'), base: false },
                          ].map((item, i) => (
                            <div key={i} style={{ display: 'flex', gap: '4px', alignItems: 'center', marginBottom: '1px' }}>
                              <span style={{ color: '#aaa', width: '28px', flexShrink: 0 }}>{item.label}</span>
                              <span style={{ color: item.base ? '#1a1a1a' : '#1D9E75', fontWeight: item.base ? '400' : '500' }}>{item.value}</span>
                            </div>
                          ));
                        })()}
                      </div>
                    </td>
                    <td style={{ padding: '10px 8px', textAlign: 'center', fontSize: '11px', color: '#666' }}>{product.created_at ? new Date(product.created_at).toLocaleDateString('ko-KR') : '-'}</td>
                    <td style={{ padding: '10px 8px', textAlign: 'center', fontSize: '11px', color: '#666' }}>{product.updated_at ? (() => { const d = new Date(product.updated_at); const p = n => String(n).padStart(2,'0'); return `${d.getFullYear()}.${p(d.getMonth()+1)}.${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`; })() : '-'}</td>
                    <td style={{ padding: '10px 8px', textAlign: 'center' }}>
                      <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexWrap: 'wrap', width: '90px', margin: '0 auto' }}>
                      {(() => {
                        const sendStatus = (product.platform_send_status || []).find(s => s.platform === 'SMARTSTORE');
                        const sent = sendStatus?.status === '전송완료';
                        const failed = sendStatus?.status === '전송실패';
                        const naverProductNo = sendStatus?.naver_channel_product_no;
                        return (
                          <button
                            onClick={() => { if (naverProductNo) window.open(`https://smartstore.naver.com/byeolmanshop/products/${naverProductNo}`, '_blank'); }}
                            disabled={!naverProductNo}
                            title={failed ? sendStatus.fail_reason : (naverProductNo ? '스마트스토어에서 보기' : '')}
                            style={{ fontSize: '11px', width: '26px', height: '26px', borderRadius: '6px', border: '0.5px solid ' + (sent ? '#1D9E75' : failed ? '#E24B4A' : '#ddd'), background: sent ? '#E1F5EE' : failed ? '#FCEBEB' : '#f5f5f5', color: sent ? '#085041' : failed ? '#A32D2D' : '#aaa', cursor: naverProductNo ? 'pointer' : 'default', fontWeight: '500' }}>
                            S
                          </button>
                        );
                      })()}
                      {(() => {
                        const sendStatus = (product.platform_send_status || []).find(s => s.platform === 'ELEVENST');
                        const sent = sendStatus?.status === '전송완료';
                        const failed = sendStatus?.status === '전송실패';
                        const elevenProductNo = sendStatus?.eleven_product_no;
                        return (
                          <button
                            onClick={() => { if (elevenProductNo) window.open(`https://www.11st.co.kr/products/${elevenProductNo}`, '_blank'); }}
                            disabled={!elevenProductNo}
                            title={failed ? sendStatus.fail_reason : (elevenProductNo ? '11번가에서 보기' : '')}
                            style={{ fontSize: '11px', width: '26px', height: '26px', borderRadius: '6px', border: '0.5px solid ' + (sent ? '#EF9F27' : failed ? '#E24B4A' : '#ddd'), background: sent ? '#FAEEDA' : failed ? '#FCEBEB' : '#f5f5f5', color: sent ? '#854F0B' : failed ? '#A32D2D' : '#aaa', cursor: elevenProductNo ? 'pointer' : 'default', fontWeight: '500' }}>
                            11
                          </button>
                        );
                      })()}
                      {(() => {
                        const sendStatus = (product.platform_send_status || []).find(s => s.platform === 'GMARKET');
                        const sent = sendStatus?.status === '전송완료';
                        const failed = sendStatus?.status === '전송실패';
                        const gmarketGoodsNo = sendStatus?.esm_goods_no;
                        return (
                          <button
                            onClick={() => { if (gmarketGoodsNo) window.open(`https://item.gmarket.co.kr/Item?goodscode=${gmarketGoodsNo}`, '_blank'); }}
                            disabled={!gmarketGoodsNo}
                            title={failed ? sendStatus.fail_reason : (gmarketGoodsNo ? '지마켓에서 보기' : '')}
                            style={{ fontSize: '11px', width: '26px', height: '26px', borderRadius: '6px', border: '0.5px solid ' + (sent ? '#185FA5' : failed ? '#E24B4A' : '#ddd'), background: sent ? '#E6F1FB' : failed ? '#FCEBEB' : '#f5f5f5', color: sent ? '#185FA5' : failed ? '#A32D2D' : '#aaa', cursor: gmarketGoodsNo ? 'pointer' : 'default', fontWeight: '500' }}>
                            G
                          </button>
                        );
                      })()}
                      {(() => {
                        const sendStatus = (product.platform_send_status || []).find(s => s.platform === 'AUCTION');
                        const sent = sendStatus?.status === '전송완료';
                        const failed = sendStatus?.status === '전송실패';
                        const auctionGoodsNo = sendStatus?.esm_goods_no;
                        return (
                          <button
                            onClick={() => { if (auctionGoodsNo) window.open(`https://itempage3.auction.co.kr/DetailView.aspx?ItemNo=${auctionGoodsNo}&frm3=V2`, '_blank'); }}
                            disabled={!auctionGoodsNo}
                            title={failed ? sendStatus.fail_reason : (auctionGoodsNo ? '옥션에서 보기' : '')}
                            style={{ fontSize: '11px', width: '26px', height: '26px', borderRadius: '6px', border: '0.5px solid ' + (sent ? '#7F77DD' : failed ? '#E24B4A' : '#ddd'), background: sent ? '#EEEDFE' : failed ? '#FCEBEB' : '#f5f5f5', color: sent ? '#3C3489' : failed ? '#A32D2D' : '#aaa', cursor: auctionGoodsNo ? 'pointer' : 'default', fontWeight: '500' }}>
                            A
                          </button>
                        );
                      })()}
                      {(() => {
                        const sendStatus = (product.platform_send_status || []).find(s => s.platform === 'COUPANG');
                        const sent = sendStatus?.status === '전송완료';
                        const failed = sendStatus?.status === '전송실패';
                        const coupangProductId = sendStatus?.coupang_product_id;
                        const coupangVendorItemId = sendStatus?.coupang_vendor_item_id;
                        return (
                          <button
                            onClick={() => { if (coupangProductId) window.open(`https://www.coupang.com/vp/products/${coupangProductId}?vendorItemId=${coupangVendorItemId}`, '_blank'); }}
                            disabled={!coupangProductId}
                            title={failed ? sendStatus.fail_reason : (coupangProductId ? '쿠팡에서 보기' : '')}
                            style={{ fontSize: '11px', width: '26px', height: '26px', borderRadius: '6px', border: '0.5px solid ' + (sent ? '#1D9E75' : failed ? '#E24B4A' : '#ddd'), background: sent ? '#E1F5EE' : failed ? '#FCEBEB' : '#f5f5f5', color: sent ? '#085041' : failed ? '#A32D2D' : '#aaa', cursor: coupangProductId ? 'pointer' : 'default', fontWeight: '500' }}>
                            C
                          </button>
                        );
                      })()}
                      {(() => {
                        // [참고 - 2026-09-04] 셀러허브 상품 상세페이지는 셀러허브 관리자 계정으로
                        // 로그인되어 있어야만 정상적으로 볼 수 있다(로그인 안 되어 있으면 로그인 페이지로 리다이렉트됨).
                        const sendStatus = (product.platform_send_status || []).find(s => s.platform === 'SELLERHUB');
                        const sent = sendStatus?.status === '전송완료';
                        const failed = sendStatus?.status === '전송실패';
                        const sellerhubGoodsNo = sendStatus?.esm_goods_no;
                        return (
                          <button
                            onClick={() => { if (sellerhubGoodsNo) window.open(`https://admin.sellerhub.co.kr/shop/goods/goods_view.php?goodsno=${sellerhubGoodsNo}`, '_blank'); }}
                            disabled={!sellerhubGoodsNo}
                            title={failed ? sendStatus.fail_reason : (sellerhubGoodsNo ? '셀러허브에서 보기 (셀러허브 관리자 로그인 필요)' : '')}
                            style={{ fontSize: '11px', width: '26px', height: '26px', borderRadius: '6px', border: '0.5px solid ' + (sent ? '#EF4444' : failed ? '#E24B4A' : '#ddd'), background: sent ? '#FEE2E2' : failed ? '#FCEBEB' : '#f5f5f5', color: sent ? '#B91C1C' : failed ? '#A32D2D' : '#aaa', cursor: sellerhubGoodsNo ? 'pointer' : 'default', fontWeight: '500' }}>
                            H
                          </button>
                        );
                      })()}
                      {(() => {
                        // [기능 추가 - 2026-09-10] 토스쇼핑 상품 목록 뱃지. esm_goods_no에 토스쇼핑 상품ID가 저장되어 있다.
                        const sendStatus = (product.platform_send_status || []).find(s => s.platform === 'TOSS');
                        const sent = sendStatus?.status === '전송완료';
                        const failed = sendStatus?.status === '전송실패';
                        const tossProductId = sendStatus?.esm_goods_no;
                        const tossItemId = sendStatus?.toss_item_id;
                        return (
                          <button
                            onClick={() => { if (tossItemId) window.open(`https://toss.shopping/i/${tossItemId}`, '_blank'); }}
                            disabled={!tossItemId}
                            title={failed ? sendStatus.fail_reason : (tossItemId ? '토스쇼핑에서 보기' : (tossProductId ? '검수 대기중' : ''))}
                            style={{ fontSize: '11px', width: '26px', height: '26px', borderRadius: '6px', border: '0.5px solid ' + (sent ? '#0064FF' : failed ? '#E24B4A' : '#ddd'), background: sent ? '#E6EEFF' : failed ? '#FCEBEB' : '#f5f5f5', color: sent ? '#0040B0' : failed ? '#A32D2D' : '#aaa', cursor: tossProductId ? 'pointer' : 'default', fontWeight: '500' }}>
                            T
                          </button>
                        );
                      })()}
                      </div>
                    </td>
                    <td style={{ padding: '10px 8px', textAlign: 'center' }}>
                      <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', marginBottom: '6px' }}>
                        <button onClick={() => setEditProduct(product)} style={{ fontSize: '11px', padding: '3px 10px', borderRadius: '6px', border: '0.5px solid #ddd', background: '#fff', cursor: 'pointer' }}>수정</button>
                        <button onClick={() => { const { id, created_at, updated_at, ...copy } = product; setEditProduct(copy); }} style={{ fontSize: '11px', padding: '3px 10px', borderRadius: '6px', border: '0.5px solid #B5D4F4', background: '#fff', color: '#185FA5', cursor: 'pointer' }}>복사</button>
                        <button onClick={() => handleDelete(product.id)} style={{ fontSize: '11px', padding: '3px 10px', borderRadius: '6px', border: '0.5px solid #ffcdd2', background: '#fff', color: '#e53935', cursor: 'pointer' }}>삭제</button>
                      </div>
                      <div style={{ borderTop: '0.5px solid #eee', paddingTop: '6px' }}>
                        <button onClick={() => setSendStatusProduct(product)} style={{ fontSize: '11px', padding: '3px 10px', borderRadius: '6px', border: '0.5px solid #ddd', background: '#fafafa', color: '#555', cursor: 'pointer' }}>오픈마켓 관리</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {total > 0 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '4px', marginTop: '16px' }}>
          <select value={pageLimit} onChange={e => { setPageLimit(parseInt(e.target.value)); setCurrentPage(1); }} style={{ fontSize: '12px', padding: '5px 8px', borderRadius: '8px', border: '0.5px solid #e8e8e8', background: '#fff', marginRight: '8px' }}>
            <option value={10}>10줄</option>
            <option value={20}>20줄</option>
            <option value={50}>50줄</option>
            <option value={100}>100줄</option>
          </select>
          <button onClick={() => setCurrentPage(p=>Math.max(1,p-1))} disabled={currentPage===1} style={{ fontSize: '12px', padding: '5px 12px', borderRadius: '8px', border: '0.5px solid #e8e8e8', background: '#fff', cursor: 'pointer' }}>이전</button>
          {(() => {
            const pages = [];
            const delta = 2;
            const left = Math.max(1, currentPage - delta);
            const right = Math.min(totalPages, currentPage + delta);
            if (left > 1) { pages.push(1); if (left > 2) pages.push('...'); }
            for (let i = left; i <= right; i++) pages.push(i);
            if (right < totalPages) { if (right < totalPages - 1) pages.push('...'); pages.push(totalPages); }
            return pages.map((p, i) => p === '...'
              ? <span key={'e'+i} style={{ fontSize: '12px', padding: '5px 4px', color: '#aaa' }}>...</span>
              : <button key={p} onClick={() => setCurrentPage(p)} style={{ fontSize: '12px', padding: '5px 10px', borderRadius: '8px', border: '0.5px solid #e8e8e8', background: currentPage===p?'#1D9E75':'#fff', color: currentPage===p?'#fff':'#1a1a1a', cursor: 'pointer' }}>{p}</button>
            );
          })()}
          <button onClick={() => setCurrentPage(p=>Math.min(totalPages,p+1))} disabled={currentPage===totalPages} style={{ fontSize: '12px', padding: '5px 12px', borderRadius: '8px', border: '0.5px solid #e8e8e8', background: '#fff', cursor: 'pointer' }}>다음</button>
          <span style={{ fontSize: '12px', color: '#aaa', marginLeft: '8px' }}>총 {total}개</span>
        </div>
      )}

      {detailProduct && (
        <ProductDetail
          product={detailProduct}
          onClose={() => setDetailProduct(null)}
          onEdit={() => { setEditProduct(detailProduct); setDetailProduct(null); }}
        />
      )}
      {sendStatusProduct && (
        <SendStatusModal
          product={sendStatusProduct}
          onClose={() => setSendStatusProduct(null)}
          onSaved={fetchProducts}
        />
      )}
    </div>
  );
}
